import React from 'react';
import { TablePagination } from '@material-ui/core';
import { useIntl } from 'react-intl';
import TablePaginationActions from './TablePaginationActions';

export interface IProps {
  id?: number;
  parentId?: string;
  label?: string;
  page: number;
  realPerPage?: number;
  perPage: number;
  total: number;
  fetchRows?: any;
  statuses?: string;
  companyId?: string;
  by_user?: boolean;
}

const TablePaginator: React.FC<IProps> = ({
  id,
  parentId,
  label,
  page,
  realPerPage,
  perPage,
  total,
  fetchRows,
  statuses,
  companyId,
  by_user,
}) => {
  const intl = useIntl();
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (fetchRows) {
      if (id) {
        fetchRows({ page: newPage,size: perPage,perPage, id });
      } else if (parentId) {
        fetchRows({ page: newPage,size: perPage, perPage, parentId: +parentId });
      } else if (statuses) {
        fetchRows({ page: newPage,size: perPage, perPage, statuses });
      } else if (companyId) {
        fetchRows({ page: newPage,size: perPage, perPage, companyId });
      } else {
        fetchRows({ page: newPage, size: perPage, perPage, by_user });
      }
    }
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (fetchRows) {
      if (id) {
        fetchRows({ page: 1, perPage: parseInt(event.target.value, 10), id });
      } else if (parentId) {
        fetchRows({ page: 1, perPage: parseInt(event.target.value, 10), parentId: +parentId });
      } else if (statuses) {
        fetchRows({ page: 1, perPage: parseInt(event.target.value, 10), statuses });
      } else if (companyId) {
        fetchRows({ page: 1, perPage: parseInt(event.target.value, 10), companyId });
      } else {
        fetchRows({ page: 1, perPage: parseInt(event.target.value, 10), by_user });
      }
    }
  };

  return (
    <TablePagination
      rowsPerPageOptions={[20]}
      count={total}
      rowsPerPage={perPage}
      page={page}
      labelRowsPerPage={label}
      // style={{border: 'none'}}
      SelectProps={{
        inputProps: { 'aria-label': 'rows per page' },
        native: true,
      }}
      onChangePage={handleChangePage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
      ActionsComponent={TablePaginationActions}
      labelDisplayedRows={({ from, to, count }) =>
        `${from}${realPerPage === 1 ? '' : '-'}${
          realPerPage === 1 ? '' : to
        } ${intl.formatMessage({
          id: 'TABLE.FROM.LABEL',
        })} ${count}`
      }
    />
  );
};

export default TablePaginator;
